import { render } from "./footerMini.vue?vue&type=template&id=02e34ab6&scoped=true"
import script from "./footerMini.vue?vue&type=script&lang=js"
export * from "./footerMini.vue?vue&type=script&lang=js"

import "./footerMini.vue?vue&type=style&index=0&id=02e34ab6&lang=css"
import "./footerMini.vue?vue&type=style&index=1&id=02e34ab6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e34ab6"]])

export default __exports__